import { NEW_PAYMENT_STACK, V3_PAYMENT_STACK } from 'shared/constants/uri';

export const getPaymentURL = (isEligibleSPCRevamp = false, grandTotal = 0): string => {
    if (isEligibleSPCRevamp && grandTotal > 0) {
        return V3_PAYMENT_STACK;
    }

    return NEW_PAYMENT_STACK;
};